<template>
  <Modal
    :mask-closable="false"
    :value="show"
    @input="changeShow">
    <div slot="header" class="modal-header">补充协议列表</div>
    <div slot="footer">
      <!--<Button type="error" size="large" long :loading="modal_loading" @click="del">Delete</Button>-->
    </div>

    <!--<div></div>-->
    <div v-if="!list.length" style="text-align: center;padding-top:20px; ">暂无数据</div>

    <ol
      class="pro-list"
      :style="{height: list.length > 5 ? '200px' :'auto' }"
      v-if="list.length !== 0">
      <li
        v-for="(item,index) in list"
        :key="index">
        <a class="pro-name" :href="item.attachmentUrl" target="_blank">{{item.attachmentName}}</a>
        <div class="pro-btn">
          <Button type="primary" size="small" @click="cancelHander(item.attachmentFid)" v-p="{api:'contract/delSupplyProtocol'}">删除</Button>
        </div>
      </li>
    </ol>
  </Modal>

</template>

<script type="text/ecmascript-6">
  import {delSupplyProtocol, getSupplyProtocolList} from '@/api/auditContract.js';

  export default {
    name: "PROTOCOLLISTMODAL",
    props: {
      value: {
        type: Boolean,
        default: false
      },
      contractFid: {
        type: Object,
        default: null
      },
    },
    data() {
      return {
        show: false,
        list: []

      }
    },
    watch: {
      // n(){
      //   this.list=[]
      //   this.show=true
      //   this.initList();
      //
      //
      // }
      value(val) {
        this.show = val;
        if (val) {
          this.initList();
        }
      }
    },
    methods: {
      changeShow(val) {
        this.show = val;
        this.$emit('input', val);
      },
      cancelHander(attachmentFid) {
        this.$Modal.confirm({
          title: '消息提醒',
          content: '<p>确定要删除该补充协议吗？</p>',
          onOk: () => {
            delSupplyProtocol({attachmentFid}).then(res => {
              this.initList();
              this.$Message.success('删除成功');
            })
          }
        })
      },
      initList() {
        getSupplyProtocolList(this.contractFid).then(res => {
          console.log(res);
          if (!res.data) {
            // this.$Message.info('补充协议列表为空')
            // this.show=false
            return

          }
          this.list = res.data;

        })
      }
    }

  }
</script>

<style lang="css" scoped>
  .pro-list {
    overflow: auto;
  }

  .pro-list li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    margin-bottom: 13px;
  }

  .pro-list li .pro-name {
    flex: 0 0 auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-decoration: underline;
  }

  .pro-btn {
    width: 50px;
    flex: 0 0 50px;
  }

</style>
